import { Alert, Button } from '@mui/material';
import { t } from 'i18next';

type Props = {
  onClick: () => void;
};

export const GenericError = ({ onClick }: Props) => {
  return (
    <Alert
      severity="error"
      action={
        <Button onClick={onClick} color="inherit" size="small">
          {t('refresh')}
        </Button>
      }
    >
      {t('loadErrorMessage')}
    </Alert>
  );
};
